module.exports = require("@mui/material/ListItemText");